import React, { Fragment, useEffect, useState } from "react"
import classnames from "classnames"
import { useAppDispatch, useAppSelector } from "../../state/hooks"
import { setCartOpen } from "../../state/menus"
import { removeItem } from "../../state/checkout"
import { LazyLoadImage } from "react-lazy-load-image-component"
import Skeleton from "react-loading-skeleton"
import { Button } from "../layout/Button"
import "./styles.scss"

const Cart: React.FC = () => {
  const [isCartDOMOpen, setIsCartDOMOpen] = useState(false)

  const dispatch = useAppDispatch()
  const isCartOpen = useAppSelector(state => state.menus.isCartOpen)

  const checkout = useAppSelector(state => state.checkout)
  const items = checkout?.lineItems?.edges || []
  const itemCount = items.reduce((pre, curr) => pre + curr.node?.quantity || 0, 0)
  const cartTotal = Number(checkout?.totalPriceV2?.amount || 0)
  const webUrl = checkout?.webUrl

  useEffect(() => {
    let cartTimeout;

    if (isCartOpen) {
      cartTimeout = setTimeout(() => {
        setIsCartDOMOpen(true)
      }, 300)
    } else {
      setIsCartDOMOpen(false)
    }

    return () => {
      clearTimeout(cartTimeout)
    }
  }, [isCartOpen])

  return (
    <>
      <div
        className={classnames(
          "cart-scrim hidden fixed h-full w-full z-40 md:block",
          {
            "pointer-events-none": !isCartDOMOpen,
            "is-visible": isCartDOMOpen,
          }
        )}
        onClick={() => dispatch(setCartOpen(false))}
      />

      <div
        className={classnames(
          "cart-overlay w-full h-full z-50 top-0 left-0 md:w-6/12 md:right-0 md:left-auto md:ml-6/12 md:pt-14 md:flex md:flex-col",
          {
            "is-closed": !isCartDOMOpen
          }
        )}
      >
        <div className="fixed top-0 h-screen bg-black w-full md:hidden"></div>

        <div className="bg-black md:border-t md:border-white h-full flex flex-col md:overflow-scroll">
          <div className="w-full text-center py-6 relative sticky top-0 z-20 bg-black">
            <button
              className="absolute left-4 top-2/4 transform -translate-y-2/4 w-16 h-16 flex items-center"
              onClick={() => dispatch(setCartOpen(false))}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            <span className="uppercase mt-1 block">Cart ({itemCount.toString().padStart(2, "0").slice(-2)})</span>
          </div>

          {itemCount <= 0 ? <p className="uppercase text-center my-24">Empty</p> :
            <div className="flex flex-col flex-1">
              <div className="sticky top-16 bg-black z-20">
                <div className="flex">
                  <div
                    className="flex-1 relative flex items-center px-8 py-10 text-center text-black bg-white justify-center"
                  >
                    <span
                      style={{ fontSize: 12 }}
                      className="absolute uppercase top-2 left-2"
                    >
                      Total Estimate
                    </span>
                    <span style={{ fontSize: 18 }}>${cartTotal} USD</span>
                  </div>

                  <a
                    href={itemCount > 0 ? webUrl : undefined}
                    style={{
                      backgroundColor: "#EBFF0A",
                      fontSize: 12,
                      lineHeight: "10px",
                    }}
                    className={`flex-1 relative flex items-center px-8 py-10 text-center text-black uppercase justify-center ${
                      itemCount > 0 ? "" : "line-through cursor-not-allowed"
                    }`}
                  >
                    Go to Checkout
                  </a>
                </div>

                <div className="relative grid grid-cols-3 gap-3 my-6">
                  <div className="col-start-2 col-span-2 grid grid-cols-2 gap-3 uppercase">
                    <span>Subtotal</span>
                    <span>${cartTotal} USD</span>

                    <span>Shipping <span style={{fontSize: '10px'}}>(est.)</span></span>
                    <span>FREE</span>

                    <span>Order Total</span>
                    <span>${cartTotal} USD</span>
                  </div>
                </div>
              </div>

            <div className="mobile-grid grid grid-cols-3 gap-3 mt-6 mb-4 uppercase px-4">
              <p>Items</p>
              <p>Description</p>
              <p className="text-right">Price</p>

              {items.map((item, i) => {
                return (
                  <Fragment key={item.node.id}>
                    <LazyLoadImage
                      src={item.node.variant?.image?.src}
                      alt={
                        item.node.variant?.image?.altText ||
                        `Line item image number ${i}.`
                      }
                      placeholder={<Skeleton />}
                    />

                    <div className="relative">
                      {item.node.title}
                      <br />
                      {item.node.variant?.selectedOptions.map((opt, i) => (
                        <Fragment key={i}>
                          {opt.value}
                          <br />
                        </Fragment>
                      ))}
                      QTY : {item.node.quantity}
                      <br />
                      <Button
                        xtraStyles={`text-xs w-auto absolute bottom-0 uppercase`}
                        rest={{
                          style: {
                            fontSize: 14,
                            padding: "0.25rem",
                          },
                        }}
                        onClick={() =>
                          dispatch(
                            removeItem(
                              item.node.id.replace(
                                "Shopify__ProductVariant__",
                                ""
                              )
                            )
                          )
                        }
                      >
                        Remove
                      </Button>
                    </div>

                    <div className="justify-self-end">
                      ${item.node.variant.price}
                    </div>
                  </Fragment>
                )
              })}
            </div>
            </div>
          }
        </div>
      </div>
    </>
  )
}

export default Cart